import React from "react";

const Contact = () => {
  return (
    <div id="contact">
      <section className="py-20 flex justify-center dark:bg-gray-500 dark:text-gray-50">
        <div className="grid max-w-6xl grid-cols-1  lg:px-8 md:grid-cols-2 md:divide-x">
          <div className="py-6 md:py-0 md:px-6">
            <div className="mb-14">
              <h1 className="text-4xl font-bold">Get in touch</h1>
              <p className="pt-2 pb-4">
                Fill in the form to start a conversation
              </p>
            </div>
            <div className=" sm:flex sm:space-x-6 md:flex-col lg:flex-row  dark:text-gray-100">
              <div className="flex-shrink-0 w-full mb-6 h-44 sm:h-32 sm:w-32 sm:mb-0">
                <img
                  src="https://i.ibb.co/kXQVB0x/IMG-20220712-WA0028.jpg"
                  alt=""
                  className="object-cover object-center sm:ml-0 lg:ml-0 md:ml-24 w-full h-full  rounded dark:bg-gray-500"
                />
              </div>
              <div className="flex flex-col mt-2 space-y-4">
                <div>
                  <h2 className="text-2xl font-semibold">MD EMON HOSSAIN</h2>
                  <span className="text-sm text-white">
                    Full Stack Developer
                  </span>
                </div>
                <div className="space-y-1">
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Email address"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M274.6,25.623a32.006,32.006,0,0,0-37.2,0L16,183.766V496H496V183.766ZM464,402.693,339.97,322.96,464,226.492ZM256,51.662,454.429,193.4,311.434,304.615,256,268.979l-55.434,35.636L57.571,193.4ZM48,226.492,172.03,322.96,48,402.693ZM464,464H48V440.735L256,307.021,464,440.735Z"
                      ></path>
                    </svg>
                    <span className="text-white">
                      mdemonhossain9527@gmail.com
                    </span>
                  </span>
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Phonenumber"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M449.366,89.648l-.685-.428L362.088,46.559,268.625,171.176l43,57.337a88.529,88.529,0,0,1-83.115,83.114l-57.336-43L46.558,362.088l42.306,85.869.356.725.429.684a25.085,25.085,0,0,0,21.393,11.857h22.344A327.836,327.836,0,0,0,461.222,133.386V111.041A25.084,25.084,0,0,0,449.366,89.648Zm-20.144,43.738c0,163.125-132.712,295.837-295.836,295.837h-18.08L87,371.76l84.18-63.135,46.867,35.149h5.333a120.535,120.535,0,0,0,120.4-120.4v-5.333l-35.149-46.866L371.759,87l57.463,28.311Z"
                      ></path>
                    </svg>
                    <span className="text-white">+8801850743162</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="p-5">
            <form
              action="https://formsubmit.co/emonhossin239@gmail.com"
              method="POST"
            >
              <label className="block my-3">
                <span className="mb-1">Full name</span>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Your Name"
                  className="block w-full p-3 rounded-md shadow-sm focus:ring focus:ring-opacity-75 focus:ring-stone-400 dark:bg-gray-800"
                />
              </label>
              <label className="block my-3">
                <span className="mb-1">Email address</span>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="YourEmail@gmail.com"
                  className="block w-full p-3 rounded-md shadow-sm focus:ring focus:ring-opacity-75 focus:ring-stone-400 dark:bg-gray-800"
                />
              </label>
              <label className="block my-3">
                <span className="mb-1">Message</span>
                <textarea
                  rows="3"
                  name="message"
                  placeholder="Your Message"
                  className="block w-full p-3 rounded-md focus:ring focus:ring-opacity-75 focus:ring-stone-400 dark:bg-gray-800"
                ></textarea>
              </label>
              <p className="bg-green-500 p-3 rounded-lg text-white">
                <button type="submit" className="">
                  Submit
                </button>
              </p>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
